import { render, staticRenderFns } from "./InputTextAndTags.vue?vue&type=template&id=f0a01ef8&scoped=true"
import script from "./InputTextAndTags.vue?vue&type=script&lang=js"
export * from "./InputTextAndTags.vue?vue&type=script&lang=js"
import style0 from "./InputTextAndTags.vue?vue&type=style&index=0&id=f0a01ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a01ef8",
  null
  
)

export default component.exports